import { useState, useEffect, useMemo } from "react";
import Header from "../../components/Header/Header";
import AboutUsContent from "../../components/AboutUsContent/AboutUsContent";
import { fetchAboutUs } from "../../services/aboutUsApi";
import { normalizeAboutUsDisplay } from "../../util/aboutUsHelpers";
import "./AboutUs.scss";

import Seo from "../../components/Seo/Seo";
import { PAGE_SEO } from "../../config/seoConfig";

function AboutUs() {
  const [carousalStatus, setCarousalStatus] = useState(true);
  const [aboutUsResponse, setAboutUsResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const handleClick = (data) => {
    setCarousalStatus(data);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const loadAboutUs = async () => {
      try {
        const response = await fetchAboutUs();
        setAboutUsResponse(response);
      } catch (error) {
        console.error("Failed to load about us data", error);
        setAboutUsResponse(null);
      } finally {
        setIsLoading(false);
      }
    };

    loadAboutUs();
  }, []);

  const aboutDisplay = useMemo(
    () => normalizeAboutUsDisplay(aboutUsResponse),
    [aboutUsResponse],
  );

  if (isLoading) {
    return (
      <div className="loader-div">
        <div className="loader">
          <lottie-player
            autoplay
            loop
            src="https://lottie.host/7d0ba31f-e11f-47ed-8248-b1a8f5389ad8/oMZAHSKOuQ.json"
          ></lottie-player>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <Seo {...PAGE_SEO.about} />
      <Header handleClick={handleClick} />
      <AboutUsContent aboutData={aboutDisplay} />
    </div>
  );
}

export default AboutUs;
